import React from 'react';
import { Link } from 'react-router-dom';
import {
  Container,
  Typography,
  Paper,
} from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { makeStyles } from '@material-ui/core/styles';
import inProgressImage from "../../../src/assets/images/in-progress.png";

const useStyles = makeStyles((theme) => ({
  updateSection: {
    padding: theme.spacing(2, 0),
  },
  bannerLink: {
    textDecoration: "none",
  },
  bannerCard: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: theme.spacing(2),
    padding: theme.spacing(1),
    borderRadius: 12,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.primary.main}`,
    // background: `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
    // color: theme.palette.common.white,
    boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0px 6px 16px rgba(0,0,0,0.25)",
      textDecoration: "none",
    },
  },
  leftSide: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    flex: 1,
  },
  icon: {
    width: 40,
    height: 40,
  },
  title: {
    fontWeight: 600,
    fontSize: "1rem",
  },
  subtitle: {
    opacity: 0.9,
    fontSize: "0.85rem",
  },
  rightSide: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    color: theme.palette.text.primary,
    padding: theme.spacing(1, 2),
    borderRadius: 8,
    fontWeight: 600,
    fontSize: "0.9rem",
  },
  chevron: {
    fontSize: "1.3rem",
  },
}));

const ProfileUpdateInfo = () => {
  const classes = useStyles();
  const signeeInfo = JSON.parse(window.localStorage.getItem("signeeInfo"));

  return (
    <>
      {signeeInfo?.status !== "COMPLIANT" && (
        <section className={classes.updateSection}>
          <Link to="/profile/documents" className={classes.bannerLink}>
            <Paper elevation={0} className={classes.bannerCard}>
              {/* Left Section */}
              <div className={classes.leftSide}>
                <img
                  src={inProgressImage}
                  alt="Profile Incomplete"
                  className={classes.icon}
                />
                <div>
                  <Typography variant="body1" className={classes.title}>
                    Your profile is not complete
                  </Typography>
                  <Typography variant="body2" className={classes.subtitle}>
                    Please update the relevant information.
                  </Typography>
                </div>
              </div>

              {/* Right Section */}
              <div className={classes.rightSide}>
                <Typography variant="body2">Complete Profile</Typography>
                <ChevronRightIcon className={classes.chevron} />
              </div>
            </Paper>
          </Link>
        </section>
      )}
    </>
  );
};

export default ProfileUpdateInfo;
